import React, { Component } from 'react';

export default class VideoPreview extends Component {
  render() {
    let sources = [];
    sources = this.props.sources.map(source => {
      return (
        <source
          src={source.url}
          type={'video/' + source.type}
          key={source.type}
        />
      );
    });

    return (
      <div style={this.props.style}>
        <video style={{ width: '100%' }}>{sources}</video>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/VideoPreview.js